import WatchListUpdateReportTableRow from './WatchListUpdateReportTableRow';

export default WatchListUpdateReportTableRow;


// WEBPACK FOOTER //
// ./src/features/reports/pages/watch-list-update-report/table/row/index.js